import { gql } from '@apollo/client';

export const CONVERSATION_CONTEXT = gql`
  query ConversationContext($input: ContentSearchContextInput!) {
    conversationContext(input: $input) {
      targetSubjectId
      targetTimestamp
      targetFound
      precedingMessages {
        id
        eventType
        createdAt
        communityId
        topicName
        contentType
        isSampled
        classificationResults {
          languageDetected
          languageClassified
          wasTranslated
          classificationType
          transcript
          processingTimeMs
          confidenceScore
          executionTimeMs
          categories
          explanation
          labels {
            labelName
            severity
            labelNumMap
            labelShortName
            labelId
            score
            contentType
          }
        }
        contentMetadata {
          subjectId
          audioFileUrl
          contentUrl
          metadata
          subjectOwner {
            type
            id
            additionalInfo
          }
          customValues
        }
      }
      followingMessages {
        id
        eventType
        createdAt
        communityId
        topicName
        contentType
        isSampled
        classificationResults {
          languageDetected
          languageClassified
          wasTranslated
          classificationType
          transcript
          processingTimeMs
          confidenceScore
          executionTimeMs
          categories
          explanation
          labels {
            labelName
            severity
            labelNumMap
            labelShortName
            labelId
            score
            contentType
          }
        }
        contentMetadata {
          subjectId
          audioFileUrl
          contentUrl
          metadata
          subjectOwner {
            type
            id
            additionalInfo
          }
          customValues
        }
      }
    }
  }
`;
